import { MessagePageCriteria } from '../model/message-page-criteria';

export namespace MessageActions {
  const prefix = '[Messages]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;
    constructor(readonly criteria: MessagePageCriteria) {}
  }

  export class RefreshPage {
    static readonly type = `${prefix} Refresh page`;
  }

  export class ClearState {
    static readonly type = `${prefix} Clear state`;
  }
}
